import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

var config = {
  apiKey: 'AIzaSyA9yyl9iCoorGlhwxWAue6fcLCqSL06gWA',
  authDomain: 'futura-c7f12.firebaseapp.com',
  databaseURL: 'https://futura-c7f12.firebaseio.com',
  projectId: 'futura-c7f12',
  storageBucket: 'futura-c7f12.appspot.com',
  messagingSenderId: '616491088441',
  appId: '1:616491088441:web:89813785b6ce6d96206be8'
}

const app = initializeApp(config)
const auth = getAuth(app)

export { auth }
